import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import AppLayout from './layout/AppLayout';
import { routesPath } from './utils/routes';
import DashboardPage from './pages/DashboardPage/DashboardPage';
import PaymentPage from './pages/PaymentPage/PaymentPage';
import IntegrationPage from './pages/IntegrationPage/IntegrationPage';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import './App.css';

const RedirectToRoot = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/');
  }, [navigate]);

  return <CircularProgress />;
};
const App = () => {
  return (
    <AppLayout>
      <Routes>
        <Route path={routesPath.root} element={<DashboardPage />} />
        <Route path={routesPath.payments} element={<PaymentPage />} />
        <Route path={routesPath.integration} element={<IntegrationPage />} />
        <Route path={routesPath.settings} element={<SettingsPage />} />
        <Route path='*' element={<RedirectToRoot />} />
      </Routes>
    </AppLayout>
  );
}

export default App;
